import { useGoogleLogin } from "@react-oauth/google"

const log = (type: string, value: any) => {
  console.log(`useGoogleOAuthService - ${type}\n` + JSON.stringify(value))
}

/**
 * https://react-oauth.vercel.app/
 * 
 * @param onSuccess success callback
 * @param onFailure failure callback
 * @returns Google auth code service
 */
const useGoogleAuthCodeLogin = (
  onSuccess: (response: any) => void,
  onFailure?: () => void
) => {
  return useGoogleLogin({
    flow: 'auth-code',
    onSuccess(codeResponse) {
      log('onSuccess', codeResponse)
      onSuccess(codeResponse)
    },
    onError(errorResponse) {
      log('onError', errorResponse)
      onFailure && onFailure()
    }
  })
}

export default useGoogleAuthCodeLogin